import {Collapse as MantineCollapse} from '@mantine/core';

/**
 * Animated show/hide container — design-layer pass-through over Mantine `Collapse`.
 * @registry Pass-through Mantine Collapse; import this instead of @mantine/core outside src/design.
 */
export const Collapse = MantineCollapse;
